export default "__VITE_ASSET__CpQtUHr8__"